import SplashAnimation from "./splash-animation";

export default SplashAnimation